import { capitalCase } from 'change-case';
import { LEGACY_BARCODE_TO_SKU_CONFIG, barcodeFieldToCamel } from 'config/legacyBarcodeToSkuConfig';

function normalizePackType(p) {
  if (p == null || p === '') return '1';
  return String(p);
}

/**
 * Resolve EAN for packing labels from product SKUs (camelCase API), with legacy product field fallback.
 *
 * @param {object} product — product row (camelCase keys, optional skus[])
 * @param {{ labelType: string, unitSize: string, palletType?: string }} opts
 * @returns {string|null}
 */
export function resolveLabelBarcode(product, opts) {
  const { labelType, unitSize, palletType } = opts || {};
  const type = labelType === 'pallet' ? palletType : labelType;
  if (!type || unitSize == null || unitSize === '') return null;

  const legacyFieldSnake = `barcode_${type}.${unitSize}`;
  const config = LEGACY_BARCODE_TO_SKU_CONFIG[legacyFieldSnake];
  const camelKey = `barcode${capitalCase(type)}.${unitSize}`;
  const skus = (product.skus || []).filter((s) => !s.deleted && !s.isLegacy);

  const legacyFromProduct = product[legacyFieldSnake] || product[camelKey];
  if (legacyFromProduct) return String(legacyFromProduct).trim();

  if (!config || !skus.length) return null;

  const targetPack = normalizePackType(config.packType);
  const candidates = skus.filter((s) => s.containerType === config.containerType
    && String(s.unitType) === String(config.unitType)
    && normalizePackType(s.packType) === targetPack);

  let sku = candidates.find((s) => !config.caseType || !s.caseType || s.caseType === config.caseType);
  if (!sku && candidates.length) {
    [sku] = candidates;
  }

  if (!sku || !config.barcodeField) return null;
  const camelField = barcodeFieldToCamel(config.barcodeField);
  const val = sku[camelField];
  return val ? String(val).trim() : null;
}

/**
 * Patch product with resolved barcode at the legacy dynamic key so Morpheus / legacy print paths work unchanged.
 */
export function patchProductLabelBarcode(product, opts) {
  const barcode = resolveLabelBarcode(product, opts);
  if (!barcode) return product;
  const { labelType, unitSize, palletType } = opts;
  const barcodeType = labelType === 'pallet' ? palletType : labelType;
  const camelKey = `barcode${capitalCase(barcodeType)}.${unitSize}`;
  return {
    ...product,
    [camelKey]: barcode,
  };
}
